export function getAchievementTitle(title: string) {
  if (title.trim().length > 30) {
    return `${ title.slice(0, 27) }...`
  } else {
    return title
  }
}
